// 21 Priority Sectors for Bholi Ko Itahari Vision 2050
export const prioritySectors = [
  {
    id: 1,
    title: "Urban Planning and Physical Infrastructure",
    nepaliTitle: "शहरी योजना तथा भौतिक पूर्वाधार",
    slug: "urban-planning",
    description: "Planned roads, bridges, housing, drainage and transport systems.",
    nepaliDescription: "सडक, पुल, ढल, आवास र यातायात प्रणालीको योजनाबद्ध विकास।",
    subRegions: 8,
    icon: "Building2"
  },
  {
    id: 2,
    title: "Security",
    nepaliTitle: "सुरक्षा",
    slug: "security",
    description: "Public safety, emergency response and city security systems.",
    nepaliDescription: "सार्वजनिक सुरक्षा, आपतकालीन प्रतिक्रिया र नगर सुरक्षा प्रणाली।",
    subRegions: 6,
    icon: "ShieldCheck"
  },
  {
    id: 3,
    title: "Drinking Water",
    nepaliTitle: "खानेपानी",
    slug: "drinking-water",
    description: "Clean, safe and reliable drinking water access for all.",
    nepaliDescription: "सबैका लागि सफा, सुरक्षित र भरपर्दो खानेपानी पहुँच।",
    subRegions: 4,
    icon: "Droplets"
  },
  {
    id: 4,
    title: "Waste and Pollution Management",
    nepaliTitle: "फोहोर तथा प्रदूषण व्यवस्थापन",
    slug: "waste-management",
    description: "Scientific waste disposal and environmental pollution control.",
    nepaliDescription: "वैज्ञानिक फोहोर व्यवस्थापन र वातावरणीय प्रदूषण नियन्त्रण।",
    subRegions: 5,
    icon: "Recycle"
  },
  {
    id: 5,
    title: "Forest, Environment and Tourism",
    nepaliTitle: "वन, वातावरण र पर्यटन",
    slug: "forest-tourism",
    description: "Green spaces, biodiversity conservation and sustainable tourism.",
    nepaliDescription: "हरित क्षेत्र, जैविक विविधता संरक्षण र दिगो पर्यटन विकास।",
    subRegions: 7,
    icon: "Trees"
  },
  {
    id: 6,
    title: "Education, Research and Knowledge",
    nepaliTitle: "शिक्षा, अनुसन्धान र ज्ञान",
    slug: "education",
    description: "Quality education and research institutions for all citizens.",
    nepaliDescription: "सबै नागरिकका लागि गुणस्तरीय शिक्षा र अनुसन्धान संस्थाहरू।",
    subRegions: 6,
    icon: "BookOpen"
  },
  {
    id: 7,
    title: "Crafts, Skills and Entrepreneurship",
    nepaliTitle: "शिल्प, सीप तथा उद्यमशीलता",
    slug: "skills-entrepreneurship",
    description: "Technical skills development and business startup support.",
    nepaliDescription: "प्राविधिक सीप विकास र उद्यम सुरुवातका लागि सहयोग।",
    subRegions: 5,
    icon: "Hammer"
  },
  {
    id: 8,
    title: "Health and Public Health",
    nepaliTitle: "स्वास्थ्य तथा जनस्वास्थ्य",
    slug: "health",
    description: "Universal healthcare services and disease prevention programs.",
    nepaliDescription: "सर्वसुलभ स्वास्थ्य सेवा र रोग रोकथाम कार्यक्रमहरू।",
    subRegions: 8,
    icon: "HeartPulse"
  },
  {
    id: 9,
    title: "Healthy Lifestyle and Consumer Rights",
    nepaliTitle: "स्वस्थ जीवनशैली र उपभोक्ता हित",
    slug: "healthy-lifestyle",
    description: "Community wellness, nutrition and consumer protection.",
    nepaliDescription: "समुदायको स्वस्थ जीवन, पोषण र उपभोक्ता हित संरक्षण।",
    subRegions: 5,
    icon: "Activity"
  },
  {
    id: 10,
    title: "Sports and Athletic Training",
    nepaliTitle: "खेलकुद तथा खेल प्रशिक्षण",
    slug: "sports",
    description: "Sports facilities and athlete development programs.",
    nepaliDescription: "खेलकुद पूर्वाधार र खेलाडी विकास कार्यक्रमहरू।",
    subRegions: 3,
    icon: "Trophy"
  },
  {
    id: 11,
    title: "Information Technology and Smart City",
    nepaliTitle: "सूचना प्रविधि तथा स्मार्ट सिटी",
    slug: "smart-city",
    description: "Digital infrastructure and IoT-enabled smart city solutions.",
    nepaliDescription: "डिजिटल पूर्वाधार र स्मार्ट सिटी समाधानहरूको विकास।",
    subRegions: 7,
    icon: "MonitorSmartphone"
  },
  {
    id: 12,
    title: "Media and Communication",
    nepaliTitle: "मिडिया, सञ्चार",
    slug: "media-communication",
    description: "Transparent government communication and public media.",
    nepaliDescription: "पारदर्शी सरकारी सञ्चार र सार्वजनिक सूचना प्रणाली।",
    subRegions: 4,
    icon: "Radio"
  },
  {
    id: 13,
    title: "Trade, Industry and Economic Development",
    nepaliTitle: "व्यापार, उद्योग र आर्थिक विकास",
    slug: "trade-industry",
    description: "Business environment, industrial growth and economic prosperity.",
    nepaliDescription: "व्यवसायमैत्री वातावरण, औद्योगिक वृद्धि र आर्थिक समृद्धि।",
    subRegions: 8,
    icon: "BriefcaseBusiness"
  },
  {
    id: 14,
    title: "Agriculture and Cooperatives",
    nepaliTitle: "कृषि तथा सहकारी",
    slug: "agriculture",
    description: "Sustainable farming practices and agricultural cooperatives.",
    nepaliDescription: "दिगो कृषि अभ्यास र कृषि सहकारीहरूको प्रवर्द्धन।",
    subRegions: 4,
    icon: "Tractor"
  },
  {
    id: 15,
    title: "Disaster Management",
    nepaliTitle: "विपद् व्यवस्थापन",
    slug: "disaster-management",
    description: "Emergency preparedness and disaster risk reduction.",
    nepaliDescription: "आपतकालीन तयारी र विपद् जोखिम न्यूनीकरण।",
    subRegions: 5,
    icon: "Siren"
  },
  {
    id: 16,
    title: "Arts, Culture and Identity",
    nepaliTitle: "कला, संस्कृति र पहिचान",
    slug: "culture-identity",
    description: "Cultural heritage preservation and artistic expression.",
    nepaliDescription: "सांस्कृतिक सम्पदा संरक्षण र कलात्मक अभिव्यक्ति प्रवर्द्धन।",
    subRegions: 6,
    icon: "Palette"
  },
  {
    id: 17,
    title: "Good Governance and Economic Policy",
    nepaliTitle: "सुशासन, आर्थिक नीति",
    slug: "governance",
    description: "Transparent administration and evidence-based policy.",
    nepaliDescription: "पारदर्शी प्रशासन र प्रमाणमा आधारित नीति निर्माण।",
    subRegions: 7,
    icon: "Scale"
  },
  {
    id: 18,
    title: "Social Security and Inclusive Development",
    nepaliTitle: "सामाजिक सुरक्षा र समावेशी विकास",
    slug: "social-security",
    description: "Social protection and equitable development for all.",
    nepaliDescription: "सबैका लागि सामाजिक संरक्षण र समान विकास।",
    subRegions: 6,
    icon: "HandHeart"
  },
  {
    id: 19,
    title: "Women, Children and Youth Development",
    nepaliTitle: "महिला, बालबालिका र युवा विकास",
    slug: "women-youth",
    description: "Empowerment and development programs for women and youth.",
    nepaliDescription: "महिला, बालबालिका र युवाका लागि सशक्तिकरण कार्यक्रम।",
    subRegions: 6,
    icon: "UsersRound"
  },
  {
    id: 20,
    title: "International Relations",
    nepaliTitle: "अन्तर्राष्ट्रिय सम्बन्ध",
    slug: "international-relations",
    description: "Global partnerships and international development cooperation.",
    nepaliDescription: "विश्वव्यापी साझेदारी र अन्तर्राष्ट्रिय विकास सहकार्य।",
    subRegions: 4,
    icon: "Globe2"
  },
  {
    id: 21,
    title: "Good Governance",
    nepaliTitle: "सुशासन",
    slug: "good-governance",
    description: "Transparent, accountable and citizen-centric administration.",
    nepaliDescription: "पारदर्शी, जवाफदेही र नागरिक केन्द्रित प्रशासन।",
    subRegions: 5,
    icon: "Landmark"
  }
];

export const getSectorBySlug = (slug) => {
  return prioritySectors.find(sector => sector.slug === slug);
};

export const getAllSectors = () => {
  return prioritySectors;
};
